// extracted by mini-css-extract-plugin
module.exports = {"Component":"AppBadge_Component__3LTJL"};